import {connect} from 'react-redux';
import ModelEdit from "../pages/ModelEdit";

export default connect(
    (state) => ({
        models: state.familyProduct.models
    }),
    (dispatch) => ({
    })
)(ModelEdit);